import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import ProfileTab from "../../../core/common/profiletab";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";

const Compensation = () => {
  const routes = all_routes;
  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Compensation </h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      My Compensation
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            <div className="row">
              <div className="col-xl-3 theiaStickySidebar">
                <div
                  className="stickybar"
                  style={{ position: "sticky", top: "50px" }}
                >
                  <ProfileTab />
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <h4>Compensation Sheet</h4>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="row justify-content-between align-items-center border-bottom mb-3">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <div className="mb-2">
                            <ImageWithBasePath
                              src="/assets/img/logo/weconnectlogo.png"
                              className="img-fluid"
                              alt="logo"
                              width={130}
                            />
                          </div>
                          <p>Near DLF Mall, Vasant Kunj New Delhi, 110070</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className=" text-end mb-3">
                          <h5 className="text-gray mb-1">
                            Payslip No{" "}
                            <span className="text-primary"> #PS4283</span>
                          </h5>
                          <p className="fw-medium">
                            Salary Month :{" "}
                            <span className="text-dark">October 2024</span>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row border-bottom align-items-center mb-3">
                      <div className="col-md-5">
                        <div className="mb-3">
                          <div>
                            <p className="mb-1">
                              <strong>Name</strong> : <span>Kumari Seni</span>
                            </p>
                            <p className="mb-1">
                              <strong>Designation</strong> :{" "}
                              <span>Senior Executive</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      {/* <h5 className="text-center mb-4 card py-3">
                        Compensation
                      </h5> */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive mb-3">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    colSpan={4}
                                    className="bg-light text-center"
                                  >
                                    Salary Components
                                  </th>
                                </tr>
                                <tr>
                                  <th>Component</th>
                                  <th>Monthly</th>
                                  <th>Annual</th>
                                  <th>Remark</th>
                                </tr>
                              </thead>
                              <tbody>
                                {/* A. Monthly Components */}
                                <tr>
                                  <td colSpan={4} className="bg-light">
                                    <strong>A. MONTHLY COMPONENTS</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Basic</td>
                                  <td>21,038</td>
                                  <td>2,52,450</td>
                                </tr>
                                <tr>
                                  <td>House Rent Allowance</td>
                                  <td>10,519</td>
                                  <td>1,26,225</td>
                                </tr>
                                <tr>
                                  <td>Special Allowance</td>
                                  <td>10,319</td>
                                  <td>1,23,825</td>
                                </tr>
                                <tr>
                                  <td>Provident Fund</td>
                                  <td>0</td>
                                  <td>0</td>
                                </tr>
                                <tr>
                                  <td>Children Education Allowance</td>
                                  <td>200</td>
                                  <td>2,400</td>
                                </tr>
                                <tr>
                                  <td>Medical Insurance</td>
                                  <td>0</td>
                                  <td>0</td>
                                </tr>
                                <tr>
                                  <td>Accidental Insurance</td>
                                  <td>0</td>
                                  <td>0</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Total (A)</strong>
                                  </td>
                                  <td>
                                    <strong>42,076</strong>
                                  </td>
                                  <td>
                                    <strong>5,04,900</strong>
                                  </td>
                                </tr>

                                {/* B. Flexible Components */}
                                <tr>
                                  <td colSpan={4} className="bg-light">
                                    <strong>B. FLEXIBLE COMPONENTS</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Variable Pay</td>
                                  <td>0</td>
                                  <td>0</td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>TOTAL CTC</strong>
                                  </td>
                                  <td></td>
                                  <td>
                                    <strong>5,04,900</strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
            <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </div>
  );
};

export default Compensation;
